import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { save, load } from 'redux-localstorage-simple';
import createLogger from 'redux-logger';

import { PersistenceWhiteList } from './constants/PersistenceWhiteList';
import callApiMiddleware from './lib/Middleware';
import getStatementByActionType from './lib/xApiStatements';
import rootReducer from './reducers';
import { xApiAnalyticsNew } from './lib/middleware/index';

// middleware
const middlewares = [callApiMiddleware, thunk, createLogger({ collapsed: true })];

middlewares.push(xApiAnalyticsNew(getStatementByActionType));

//create store
const store = createStore(
    rootReducer,
    load({ states: PersistenceWhiteList, namespace: 'CreaVerificheZanichelli' }),
    applyMiddleware(...middlewares, save({ states: PersistenceWhiteList, namespace: 'CreaVerificheZanichelli' }))
);

export default store;
